export default "__VITE_ASSET__CMZCiQVn__"